import React, { useEffect } from 'react';
import { Input, InputIcon, BrandBand } from '@salesforce/design-system-react';
import './settings.css';
import TreeMenu from '../../components/Menus/TreeMenu';
// import Users from './users';
// import Permissions from './permissions';
// import DefiPublicAddress from './accounts/defiPublicAddress';
// import Exchanges from './accounts/exchanges';
// import Conditions from './conditions/conditions';
// import Contracts from './addressBook/contracts';
// import Contacts from './addressBook/contacts';
// import AddressBook from './conditions/addressBook';
import { Outlet } from 'react-router-dom';
// import { ThemeContext } from '../../context/ThemeContext';

const Settings = () => {
  // const { isDarkTheme } = useContext(ThemeContext);

  // const menus = {
  //   Administration: {
  //     0: {
  //       id: 0,
  //       nodes: [1, 2],
  //     },
  //     1: {
  //       label: 'Users',
  //       link: 'users',
  //       type: 'branch',
  //       id: 1,
  //       nodes: [3, 4],
  //     },
  //     2: {
  //       label: 'Label',
  //       link: 'label',
  //       type: 'branch',
  //       id: 2,
  //     },
  //     3: {
  //       label: 'Users',
  //       link: 'users',
  //       type: 'item',
  //       id: 3,
  //     },
  //     4: {
  //       label: 'Permissions',
  //       link: 'permissions',
  //       type: 'item',
  //       id: 4,
  //     },
  //   },
  //   Accounts: {
  //     0: {
  //       id: 0,
  //       nodes: [1, 2],
  //     },
  //     1: {
  //       id: 1,
  //       label: 'Defi Public Addresses',
  //       link: 'defi-public-addresses',

  //       type: 'item',
  //     },
  //     2: {
  //       id: 2,
  //       label: 'Exchanges',
  //       link: 'exchanges',
  //       type: 'item',
  //     },
  //   },
  //   Conditions: {
  //     0: {
  //       id: 0,
  //       nodes: [1],
  //     },
  //     1: {
  //       id: 1,
  //       label: 'Conditions',
  //       link: 'conditions',
  //       type: 'item',
  //     },
  //   },
  //   'Address Book': {
  //     0: {
  //       id: 0,
  //       nodes: [1, 2],
  //     },
  //     1: {
  //       id: 1,
  //       label: 'Contacts',
  //       link: 'contacts',
  //       type: 'item',
  //     },
  //     2: {
  //       id: 2,
  //       label: 'Contracts',
  //       link: 'contracts',
  //       type: 'item',
  //     },
  //   },

  //   Interface: {
  //     0: {
  //       id: 0,
  //       nodes: [1],
  //     },
  //     1: {
  //       id: 1,
  //       link: 'theme',
  //       label: `Switch to ${isDarkTheme === true ? 'Light Theme' : 'Dark Theme'}`,
  //       type: 'item',
  //     },
  //   },
  // };

  // const renderSelectedMenuPage = () => {
  //   const page = new URLSearchParams(window.location.search).get('page');
  //   switch (page) {
  //     case 'users':
  //       return <Users />;
  //     case 'permission':
  //       return <Permissions />;
  //     case 'defi-public-addresses':
  //       return <DefiPublicAddress />;
  //     case 'exchanges':
  //       return <Exchanges />;
  //     case 'conditions':
  //       return <Conditions />;
  //     case 'address-book':
  //       return <AddressBook />;
  //     case 'contracts':
  //       return <Contracts />;
  //     case 'contacts':
  //       return <Contacts />;
  //     default:
  //       return <Users />;
  //   }
  // };

  return (
    <BrandBand id="brand-band-default" style={{ paddingLeft: '0px' }}>
      <div className="slds-grid slds-wrap pageContent">
        {/* Left Section Sidebar*/}

        <div className="slds-col slds-size_1-of-1 slds-small-size_6-of-12  slds-medium-size_4-of-12 slds-large-size_3-of-12">
          <div className="left-sidebar">
            {/* <Input
              className="slds-p-around_medium"
              iconLeft={
                <InputIcon
                  assistiveText={{
                    icon: 'Search',
                  }}
                  name="search"
                  category="utility"
                />
              }
              id="unique-id-1"
              placeholder="Quick Find"
            /> */}
            <TreeMenu />
          </div>
        </div>

        {/* Right Section */}
        <div className="slds-col slds-size_1-of-1 slds-small-size_6-of-12 slds-medium-size_8-of-12 slds-large-size_9-of-12">
          {/* {renderSelectedMenuPage()} */}
          <Outlet />
          {/* <Routes>
            <Route
              path={'/settings/user'}
              element={<PrivateRoute>{Users}</PrivateRoute>}
              key={'/settings/user'}
            />
          </Routes> */}
        </div>
      </div>
    </BrandBand>
  );
};

export default Settings;
